import { PDFViewer, Document, Page, View, StyleSheet, Text, Image, Font } from "@react-pdf/renderer";
import { useParams } from 'react-router-dom';
import imgQR from '../../assets/images/qr.png';
import srcRobotoItalic from '../../assets/custom/font/roboto/Roboto-Italic.ttf';
import srcArialBold from '../../assets/custom/font/arial/ARIBL0.ttf';
import { useEffect, useMemo, useState, useRef } from "react";
import ViewService from "../../services/view/ViewService";
import { QRCodeCanvas } from 'qrcode.react';

Font.register({ family: 'Roboto-Italic', src: srcRobotoItalic })
Font.register({ family: 'Arial MT Black', src: srcArialBold })

const styles = StyleSheet.create({
    page: {
        paddingTop: 20,
        paddingBottom: 48,
        paddingHorizontal: 48,
        boxSizing: "border-box"
    },
    headingEn: {
        fontFamily: "Arial MT Black",
        fontSize: 9,
        textAlign: "center",
    },
    textBox: {
        fontSize: 8,
    },
    textBoxInf: {
        fontSize: 7,
        textAlign: "center",
    },
    table: {
        border: '1 solid black',
        display: 'table',
        width: 'auto',
    },
    tableCon1: {
        borderBottom: '1 solid black',
        borderRight: '1 solid black',
        display: 'table',
        width: '50%',
    },
    tableCon2: {
        borderBottom: '1 solid black',
        display: 'table',
        width: '50%',
    },
    tableRow: {
        flexDirection: 'row',
    },
    tableCol1: {
        width: '30%',
        padding: 5,
        textAlign: 'left',
    },
    tableCol2: {
        width: '5%',
        padding: 5,
        textAlign: 'left',
    },
    tableCol3: {
        width: '60%',
        padding: 5,
        textAlign: 'left',
    },
    tableBox: {
        width: 'auto',
        display: 'table'
    },
    textEn: {
        fontSize: 6,
        textAlign: "left"
    },
    textIn: {
        fontFamily: "Roboto-Italic",
        fontSize: 6,
        textAlign: "left",
    },
    textEnBold: {
        fontFamily: "Arial MT Black",
        fontSize: 6
    },
    tableColBoxCon1: {
        padding: 2,
        textAlign: 'left',
    },
    tableColBoxCon2: {
        padding: 2,
        textAlign: 'left',
    },
    ImgQr: {
        width: 60,
        height: 60,
        marginVertical: 5,
        marginHorizontal: 130,
    }
})

const QRCode = () => {
    const viewServ = useMemo(() => new ViewService(), [])
    const { noAju } = useParams()
    const [dataHc, setDataHc] = useState(null)
    const [negaraTujuan, setNegaraTujuan] = useState(null)
    const [kdNegaraTujuan, setKdNegaraTujuan] = useState(null)
    const [qrImage, setQrImage] = useState(null)
    const qrImageCanvas = useRef()
    const qrText = "https://siapmutu.kkp.go.id/view-smkhp/"+noAju

    const getQRCodeDataURL = (canvasRef) => {
        return new Promise((resolve) => {
            setTimeout(() => {
                const canvas = canvasRef.current?.children[0]; // Get the canvas inside <QRCode />
                if (canvas) {
                    resolve(canvas.toDataURL("image/png")); // Convert to Base64
                } else {
                    resolve(null);
                }
            }, 500); // Delay to ensure QR code renders
        });
    };

    useEffect(() => {
        const generateQrCode = async () => {
            const dataUrl = await getQRCodeDataURL(qrImageCanvas)
            setQrImage(dataUrl)
        }
        generateQrCode()
    }, [])

    useEffect(() => {
        const fetchAllData = async () => {
            try {
                getHc(noAju);
                getNegaraTujuan(kdNegaraTujuan)

            } catch (error) {
                console.log(error);
            }
        }
        fetchAllData()
    }, [noAju, kdNegaraTujuan])

    const getHc = async (noAju) => {
        try {
            const response = await viewServ.getHcByAju(noAju);
            setDataHc(response.data);
            setKdNegaraTujuan(response.data.kd_ngr_tujuan)
        } catch (error) {
            console.log(error);
        }
    };

    const getNegaraTujuan = async (kdNegaraTujuan) => {
        try {
            const response = await viewServ.getNegaraByAju(kdNegaraTujuan);
            setNegaraTujuan(response.data);
        } catch (error) {
            console.log(error);
        }
    };

    const formatDate = (originalFormat) => {
        const date = new Date(originalFormat);
        const options = { year: "numeric", month: "long", day: "numeric" };
        let formattedDate = date.toLocaleDateString("en-US", options);
        return formattedDate;
    };

    return (
        <>
            <div ref={qrImageCanvas} style={{ display: "none" }}>
                <QRCodeCanvas value={qrText} size={100} />
            </div>
            <PDFViewer style={{ width: 1105, height: 800 }}>
                <Document>
                    <Page size="A6" orientation="landscape" style={styles.page}>
                        <View>
                            <Text style={styles.headingEn}>REFERENCE NO. </Text>
                            <Text style={styles.headingEn}>{dataHc !== null ? dataHc.no_hc_mutu : ''}</Text>
                        </View>
                        <View style={[styles.table, { paddingTop: 10, border: 0 }]}></View>
                        <View style={[styles.table, { borderBottom: 0 }]}>
                            <View style={[styles.tableRow, { borderBottom: 0 }]}>
                                <View style={styles.tableCon1}>
                                    <View style={styles.tableRow}>
                                        <View style={styles.tableColBoxCon1}>
                                            <Text style={styles.textEnBold}>Origin Country : </Text>
                                        </View>
                                        <View style={styles.tableColBoxCon2}>
                                            <Text style={styles.textEn}>Indonesia</Text>
                                        </View>
                                    </View>
                                    <View style={styles.tableRow}>
                                        <View style={styles.tableColBoxCon1}>
                                            <Text style={styles.textEnBold}>Consignor : </Text>
                                        </View>
                                        <View style={styles.tableColBoxCon2}>
                                            <Text style={styles.textEn}>{dataHc !== null ? dataHc.nm_pengirim : ''}</Text>
                                        </View>
                                    </View>
                                    <View style={styles.tableRow}>
                                        <View style={styles.tableColBoxCon1}>
                                            <Text style={styles.textEnBold}>System ID : </Text>
                                        </View>
                                        <View style={styles.tableColBoxCon2}>
                                            <Text style={styles.textIn}>{noAju}</Text>
                                        </View>
                                    </View>
                                </View>
                                <View style={styles.tableCon2}>
                                    <View style={styles.tableRow}>
                                        <View style={styles.tableColBoxCon1}>
                                            <Text style={styles.textEnBold}>Country of Destination : </Text>
                                        </View>
                                        <View style={styles.tableColBoxCon2}>
                                            <Text style={styles.textEn}>{negaraTujuan !== null ? negaraTujuan.URAIAN_NEGARA : '-'}</Text>
                                        </View>
                                    </View>
                                    <View style={styles.tableRow}>
                                        <View style={styles.tableColBoxCon1}>
                                            <Text style={styles.textEnBold}>Consignee : </Text>
                                        </View>
                                        <View style={styles.tableColBoxCon2}>
                                            <Text style={styles.textIn}>{dataHc !== null ? dataHc.nm_penerima : ''}</Text>
                                        </View>
                                    </View>
                                </View>
                            </View>
                        </View>
                        <View style={[styles.table, { paddingTop: 10, border: 0 }]}></View>
                        <View style={[styles.table, { border: 1 }]}>
                            <View style={styles.tableCol}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textEnBold}>QRCode :</Text>
                                </View>
                                <View style={styles.ImgQr}>
                                    <Image src={qrImage} style={{ width: 60, height: 60 }} />
                                </View>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={styles.textBoxInf}>{dataHc !== null ? `Date Created :  ${formatDate(dataHc.tgl_hc)}` : ''}</Text>
                            </View>
                        </View>
                    </Page>
                </Document>
            </PDFViewer>
        </>
    )
}

export default QRCode